var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupportGroups(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19605_50850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.43562 16.6985C12.1401 16.6985 15.1432 13.6954 15.1432 9.99092C15.1432 6.28642 12.1401 3.28333 8.43562 3.28333C4.73112 3.28333 1.72803 6.28642 1.72803 9.99092C1.72803 13.6954 4.73112 16.6985 8.43562 16.6985Z",
    fill: "#FC92A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.58342 15.6731C6.03113 15.6731 5.58342 16.1287 5.58342 16.6907C5.58342 17.2527 6.03113 17.7083 6.58342 17.7083L12.2501 17.7083C14.4592 17.7083 16.2501 15.8859 16.2501 13.6379C16.2501 10.1652 12.2423 7.87128 9.5801 6.69422C9.0149 6.44432 8.50414 6.48375 8.18737 6.94412C7.48683 7.96218 9.03618 8.95916 9.65008 9.56754M9.58341 15.6731H5.25008C4.6978 15.6731 4.25008 15.2175 4.25008 14.6555C4.25008 14.0935 4.6978 13.6379 5.25008 13.6379M9.58342 13.6379H3.91675C3.36446 13.6379 2.91675 13.1823 2.91675 12.6203C2.91675 12.0583 3.36446 11.6027 3.91675 11.6027H5.58341M9.58341 9.56754H5.25008C4.6978 9.56754 4.25008 10.0231 4.25008 10.5851C4.25008 11.1471 4.6978 11.6027 5.25008 11.6027H9.58341",
    stroke: "#213332",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 9.79171C16.6672 7.29171 14.587 2.50004 12.5068 2.29171C12.0928 2.25025 11.1598 2.71858 11.6747 3.75004C12.066 4.5338 12.0907 5.62504 12.0907 5.62504C12.0907 5.62504 8.34638 3.95838 7.09824 3.95838C5.85009 3.95838 5.43406 5.20838 6.26617 6.04171",
    stroke: "#213332",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19605_50850"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.8849,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportGroups);
export default __webpack_public_path__ + "static/media/support_groups.0ef1ecab84f71528ada7f3d2be83c31c.svg";
export { ForwardRef as ReactComponent };